import { format, formatDistanceToNow } from 'date-fns';
import { ar, enUS } from 'date-fns/locale';
import { useLanguageStore } from '@/store/languageStore';

export const getDateLocale = () => {
  const language = useLanguageStore.getState().language;
  return language === 'ar' ? ar : enUS;
};

export const formatDate = (date: Date | string | number, formatStr: string) => {
  return format(new Date(date), formatStr, {
    locale: getDateLocale(),
  });
};

export const formatDateRelative = (date: Date | string | number) => {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
    locale: getDateLocale(),
  });
};
